import React from 'react'
import MaterialSymbol from '../material-symbol'

const PeopleAlt = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="people_alt" {...props} />
))

PeopleAlt.displayName = 'PeopleAlt'

export default PeopleAlt
